import { ArrowRightAlt } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { SECONDARY_THEME_COLOR } from "../../../../providers/theme/colors/colors";
import useAboutLeaders from "../../../about/use_about_leaders";
import { buildAboutSummary } from "../../../about/about_data";

export default function AboutUs() {
  const navigate = useNavigate();
  const { leaders } = useAboutLeaders();
  return (
    <Box mt={4}>
      <Typography variant="h4" fontWeight={"600"}>
        About
      </Typography>
      <Typography variant="h5">
        SAMMITRA, Youth Commission - Diocese of Udupi
      </Typography>
      <Box mt={2}>
        <Typography variant="subtitle1">
          {buildAboutSummary(leaders)}
        </Typography>
        <Box
          display={"flex"}
          mt={1}
          borderBottom={`3px solid ${SECONDARY_THEME_COLOR}`}
          width={"fit-content"}
          onClick={() => {
            navigate("/about");
            window.scrollTo(0, 0);
          }}
          sx={{ cursor: "pointer" }}
        >
          <Typography variant="body2" fontWeight={"600"}>
            Read more
          </Typography>
          <IconButton
            style={{ margin: 0, padding: 0 }}
            onClick={() => {
              navigate("/about");
              window.scrollTo(0, 0);
            }}
          >
            <ArrowRightAlt />
          </IconButton>
        </Box>
      </Box>
      <Box mt={4} />
    </Box>
  );
}
